/**
 * HTML to plain text with a little structure kept (headings, list items, line breaks), for the help search and for the text the
 * help assistant answers from. Needs DOMParser: the browser, or the jsdom of the tests.
 */
const SKIP = new Set(['SCRIPT', 'STYLE', 'SVG', 'NOSCRIPT', 'HEAD']);
const BLOCK = new Set(['P', 'DIV', 'UL', 'OL', 'TABLE', 'TR', 'SECTION', 'ARTICLE', 'HEADER', 'FOOTER', 'BLOCKQUOTE', 'PRE', 'DL', 'DT', 'DD', 'FIGURE']);

function walk(node, out) {
  if (node.nodeType === 3) {
    out.push(node.nodeValue);
    return;
  }
  if (node.nodeType !== 1 || SKIP.has(node.tagName.toUpperCase())) return;
  const tag = node.tagName.toUpperCase();
  if (/^H[1-6]$/.test(tag)) {
    out.push('\n\n### ');
  } else if (tag === 'LI') {
    out.push('\n- ');
  } else if (tag === 'BR') {
    out.push('\n');
  } else if (tag === 'TD' || tag === 'TH') {
    out.push(' | ');
  } else if (BLOCK.has(tag)) {
    out.push('\n');
  }
  node.childNodes.forEach((child) => walk(child, out));
  if (/^H[1-6]$/.test(tag) || BLOCK.has(tag)) out.push('\n');
}

export function htmlToText(html) {
  const doc = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html');
  const out = [];
  walk(doc.body, out);
  return out.join('')
    .replace(/[ \t ]+/g, ' ')
    .replace(/ *\n */g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

/** A whole HTML page (with <head>, <style>): its body text. */
export function pageToText(html) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  doc.querySelectorAll('script, style, svg, nav').forEach((el) => el.remove());
  return htmlToText(doc.body.innerHTML);
}
